module.exports = __webpack_public_path__ + "img/certificate_bg.153883ad.jpg";